<template>
  <div class="terms-container">
    <div class="gradient-background">
      
        <div class="content">
        <img src="/assets/Logo.png" alt="Mistock.co Logo" class="logo">
        <div class="success-message">
          <i class="fa fa-exclamation-circle"></i>
          <h1>Pago Fallido</h1>
        </div>
        <div class="payment-details" hidden>
          <h2>Detalles del Pago</h2>
          <p><strong>Fecha:</strong></p>
          <p><strong>Número de Transacción:</strong> #12345678</p>
          <p><strong>Monto:</strong> $99.99</p>
          
        </div>
        <p class="thank-you-message">Lo sentimos, tu pago no pudo ser procesado. Por favor, verifica tu información de pago e intenta nuevamente.</p>
        <button @click="goToLogin" class="dashboard-button">
          Ir al Dashboard
        </button>
      </div>
    
    </div>
  </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];

export default {
  name: 'Terms',
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToLogin() {
      this.$router.push({ name: 'Login' });
    },
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
}
</script>

<style scoped>
.payment-success-container {
  min-height: 100vh;
  font-family: Arial, sans-serif;
}

.gradient-background {
  background: linear-gradient(to bottom, #706f6f, #4a4949, #2c2c2c);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.content {
  max-width: 600px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 40px;
  text-align: center;
}

.logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin: 0 auto 30px;
}

.success-message {
  margin-bottom: 30px;
}

.success-message i {
  font-size: 60px;
  color: orange;
  margin-bottom: 20px;
}

.success-message h1 {
  font-size: 28px;
  color: #f9b000;
  font-weight: bold;
}

.payment-details {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
  text-align: left;
}

.payment-details h2 {
  font-size: 20px;
  color: #f9b000;
  margin-bottom: 15px;
}

.payment-details p {
  color: #fff;
  margin-bottom: 10px;
}

.thank-you-message {
  color: #fff;
  font-size: 18px;
  margin-bottom: 30px;
}

.dashboard-button {
  background-color: #f9b000;
  color: #2c2c2c;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dashboard-button:hover {
  background-color: #ffca4d;
}
</style>